import React from 'react';
import { firstError } from '@/utils/errors';
import CloseButton from '@/components/buttons/CloseButton';
import ForwardButton from '@/components/buttons/ForwardButton';
import TabActions from '@/components/tabs/TabActions';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const SelectSourceActions = ({ category, code, compact }) => {
  const { readErrors, sources, sourceUrl } = Selectors.useSelectSourceActions({ category, code });
  const cancelRequest = Events.useDestroyRequests();
  const addSources = Events.useAddSourcesToRequest(category, { code });

  return (
    <TabActions className="aridhia-request-access-wizard-actions">
      <CloseButton
        onClick={() => cancelRequest({
          items: [{ code, isNew: true, steps: { sourceUrl } }],
          isArchival: false,
          silent: true,
        })}
      />
      <ForwardButton
        onClick={addSources}
        disabled={sources.length === 0 || firstError(readErrors)}
        iconOnly={compact}
      />
    </TabActions>
  );
};

export default SelectSourceActions;
